import {
	forwardRef,
	ReactElement,
	Ref
} from "react";
import { IconButton } from "../IconButton/IconButton";
import { localize } from "client_legacy/ndaw/culture";

export type ReorderableListAddButtonClickEventArgs = {
	clientX: number;
	clientY: number;
};

export type ReorderableListAddButtonProps = {
	onClick(args: ReorderableListAddButtonClickEventArgs): void;
	trackingId?: string;
};

export const ReorderableListAddButton = forwardRef((props: ReorderableListAddButtonProps, ref: Ref<HTMLButtonElement>): ReactElement => {
	const {
		trackingId, onClick
	} = props;

	const clickHandler = (args: React.MouseEvent): void => {
		const {
			clientX,
			clientY
		} = args;

		onClick({ clientX, clientY });
	};

	return (
		<div>
			<IconButton
				ref={ref}
				kind="dashed"
				icon="plus"
				width="fill"
				onClick={clickHandler}
				trackingId={trackingId}
				tooltip={localize("_Add")}
			/>
		</div>
	);
});

ReorderableListAddButton.displayName = "ReorderableList.AddButton";
